export enum AppointmentStatus{
    T = 'AguardandoTriagem',
    ET = 'EmTriagem',
    A = 'AguardandoAtendimento',
    EA = 'EmAtendimento',
    V = 'Realizado',
    X = 'Ausente',
    EC = 'Encaixe',
    C = 'confirmado'
}

export const getDescricaoByCodigoAppointmentStatus = (codigo: string)=>{
    switch(codigo){
        case AppointmentStatus.T:
        case 'aguardandotriagem':
            return 'Aguardando triagem'
        case AppointmentStatus.ET:
        case 'emtriagem':
            return 'Em triagem'
        case AppointmentStatus.A:
        case 'aguardandoatendimento':
            return 'Aguardando atendimento'
        case AppointmentStatus.EA:
        case 'ematendimento':
            return 'Em atendimento'    
        case AppointmentStatus.V:
        case 'realizado':
            return 'Realizado'    
        case AppointmentStatus.X:
        case 'ausente':
            return 'Ausente'
        case AppointmentStatus.EC:
        case 'encaixe':
            return ''
        case AppointmentStatus.C:
        case 'confirmado':
            return 'Confirmado'
    }
}

export const getDescricaoByCodigoFormat = (codigo: string)=>{
    const values: string[] = Object.values(AppointmentStatus)
    const keys: string[] = Object.keys(AppointmentStatus)

    const index = keys.indexOf(codigo)
    return values[index]
}

export const getCodigoByDescricaoFormat = (desc: string)=>{
    const values: string[] = Object.values(AppointmentStatus)
    const keys: string[] = Object.keys(AppointmentStatus)

    const index = values.indexOf(desc)
    return keys[index]
}

export const getEnumAsObject = ()=>{
    const values: string[] = Object.values(AppointmentStatus)
    const enumValues: any[] = []

    values.forEach((v: any)=>{
        const object = {value: v, id: getCodigoByDescricaoFormat(v), desc: getDescricaoByCodigoAppointmentStatus(v)}
        if(['T','ET','A','EA'].includes(object.id)){
            enumValues.push(object)
        }
    })

    return enumValues;
}